export default "__VITE_ASSET__npMy6uyw__"